<template>
    <div :class="b()" id="disabledBlockWrap">
        <i class="fa fa-spinner fa-spin spinner-center"></i>

        <div class="row" v-if="this.user" id="disabledBlock">

            <div class="col-md-3">

                <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                        <div class="text-center">
                            <img class="profile-user-img img-fluid img-circle" src="/crm/img/crm_user_mt.png"
                                 alt="User profile picture">
                        </div>
                        <h3 class="profile-username text-center">{{ this.user.corpName }}</h3>
                        <h2 class="text-center">{{ this.user.name }}</h2>
                        <p class="text-muted text-center">{{ this.user.type }}</p>
                        <ul class="list-group list-group-unbordered mb-3">
                            <li class="list-group-item" v-if="this.user.createdAt">
                                <b>Дата регистрации</b> <a class="float-right">{{ this.user.createdAt }}</a>
                            </li>
                            <li class="list-group-item">
                                <b>Email</b> <a class="float-right">{{ this.user.email }}</a>
                            </li>
                            <li class="list-group-item" v-if="this.user.city">
                                <b>Город</b> <a class="float-right">{{ this.user.city }}</a>
                            </li>
                            <li class="list-group-item" v-if="!this.user.isDetectedCrm">
                                <b>Статус</b> <a class="float-right">{{ this.user.status }}</a>
                            </li>
                            <li class="list-group-item">
                                <b>Баланс</b> <a class="float-right">{{ this.user.money }} р.</a>
                            </li>
                            <li class="list-group-item" v-show="this.user.authResponsible.isAuthAnotherUser">
                                <a :href="'/admin/users/login-another-user?user_id=' + this.user.id" class="btn btn-info btn-block">Авторизироваться</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="card">
                    <div class="card-header p-2">
                        <ul class="nav nav-pills">
                            <li class="nav-item"><a class="nav-link active" href="#user_info" data-toggle="tab">Информация</a></li>
                            <li class="nav-item"><a class="nav-link" href="#timeline" data-toggle="tab">История</a></li>
                            <template v-if="this.user.isBuyer">
                                <li class="nav-item"><a class="nav-link" href="#scores" data-toggle="tab">Счета</a></li>
                                <li class="nav-item"><a class="nav-link" href="#requests" data-toggle="tab">Заявки</a></li>
                            </template>
                            <li class="nav-item"><a class="nav-link" href="#buyings" data-toggle="tab">Закупки</a></li>
                            <li class="nav-item"><a class="nav-link" href="#wallet" data-toggle="tab">Баланс</a></li>
                            <li class="nav-item"><a class="nav-link" href="#settings" data-toggle="tab">Настройки</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <div class="tab-pane active" id="user_info">
                                <div class="row">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                           <tr>
                                               <td><strong><i class="far fa-building"></i> Компания</strong></td>
                                               <td><p class="text-muted">{{ this.user.corpName }}</p></td>
                                           </tr>
                                            <tr>
                                                <td><strong><i class="fas fa-street-view"></i> Директор</strong></td>
                                                <td><p class="text-muted">{{ this.user.directorFullName }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong><i class="fas fa-map-marker-alt"></i> Официальный адрес</strong></td>
                                                <td><p class="text-muted">{{ this.user.officialSeat }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong><i class="fas fa-map-marker"></i> Актуальный адрес</strong></td>
                                                <td><p class="text-muted">{{ this.user.actualAddress }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong><i class="far fa-id-badge"></i> Контактное лицо</strong></td>
                                                <td><p class="text-muted">{{ this.user.contactsFio }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong><i class="fas fa-phone-volume"></i> Контактный телефон</strong></td>
                                                <td><p class="text-muted">{{ this.user.contactsPhone }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong><i class="far fa-envelope-open"></i> Контактный email</strong></td>
                                                <td><p class="text-muted">{{ this.user.contactsEmail }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong><i class="fas fa-briefcase"></i> Должность</strong></td>
                                                <td><p class="text-muted">{{ this.user.contactsVacancy }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> ИНН</strong></td>
                                                <td><p class="text-muted">{{ this.user.taxRefNum }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> КПП</strong></td>
                                                <td><p class="text-muted">{{ this.user.taxReasonCode }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> ОГРН</strong></td>
                                                <td><p class="text-muted">{{ this.user.psrn }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> Расчетный счет</strong></td>
                                                <td><p class="text-muted">{{ this.user.transactionAccount }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> Корр. счет</strong></td>
                                                <td><p class="text-muted">{{ this.user.correspondentAccount }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> БИК</strong></td>
                                                <td><p class="text-muted">{{ this.user.rcbic }}</p></td>
                                            </tr>
                                            <tr>
                                                <td><strong> Форма налогообложения</strong></td>
                                                <td><p class="text-muted">{{ this.user.taxForm }}</p></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="timeline">
                                <div class="row">

                                    <!-- Статистика для покупателя -->
<!--                                    <template v-if="this.user.isBuyer && !this.user.isDetectedCrm">-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box mb-3">-->
<!--                                                <span class="info-box-icon bg-success elevation-1"><i class="fas fa-shopping-cart"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Купил всего позиций</span>-->
<!--                                                    <span class="info-box-number">{{ this.user.numberPurchasedItems }}</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box">-->
<!--                                                <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Любая статистика</span>-->
<!--                                                    <span class="info-box-number">-</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box">-->
<!--                                                <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Любая статистика</span>-->
<!--                                                    <span class="info-box-number">-</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box">-->
<!--                                                <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Любая статистика</span>-->
<!--                                                    <span class="info-box-number">-</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </template>-->

                                    <!-- Статистика для поставшика -->
<!--                                    <template v-if="this.user.isSeller && !this.user.isDetectedCrm">-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box mb-3">-->
<!--                                                <span class="info-box-icon bg-success elevation-1"><i class="fas fa-hand-holding-usd"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Снизил цену</span>-->
<!--                                                    <span class="info-box-number">{{ this.user.numberOfferItems }} <small>раз</small></span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box">-->
<!--                                                <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Любая статистика</span>-->
<!--                                                    <span class="info-box-number">-</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box">-->
<!--                                                <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Любая статистика</span>-->
<!--                                                    <span class="info-box-number">-</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-12 col-sm-6 col-md-3">-->
<!--                                            <div class="info-box">-->
<!--                                                <span class="info-box-icon bg-info elevation-1"><i class="fas fa-cog"></i></span>-->
<!--                                                <div class="info-box-content">-->
<!--                                                    <span class="info-box-text">Любая статистика</span>-->
<!--                                                    <span class="info-box-number">-</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </template>-->
                                </div>


                                <div class="card  card-tabs">
                                    <div class="card-header p-0 pt-1 border-bottom-0">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="custom-tabs-two-home-tab"
                                                   data-toggle="pill" href="#entityAddComment" role="tab"
                                                   aria-controls="custom-tabs-two-home"
                                                   aria-selected="true">Новый комментарий</a>
                                            </li>
                                            <template v-if="this.user.isBuyer">
                                                <li class="nav-item">
                                                    <a class="nav-link" id="custom-tabs-score"
                                                       data-toggle="pill" href="#entityAddScore" role="tab"
                                                       aria-controls="custom-tabs-two-home"
                                                       aria-selected="true">Новый счет</a>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                    <div class="card-body">
                                        <div class="tab-content">
                                            <div class="tab-pane fade active show" id="entityAddComment" role="tabpanel"
                                                 aria-labelledby="custom-tabs-two-home-tab">
                                                <div class="form-group">
                                                    <textarea
                                                            @focus="onFocusButtonsComment"
                                                            v-model="historyCommentText"
                                                            class="form-control"
                                                            rows="1"
                                                            placeholder="Введите комментарий для пользователя.."></textarea>
                                                </div>
                                                <div class="form-group" v-show="buttonsCommentFocused">
                                                    <button v-on:click="sendComment()" type="button"
                                                            class="btn btn-primary">Отправить
                                                    </button>
                                                </div>
                                            </div>
                                            <template v-if="this.user.isBuyer">
                                                <div class="tab-pane fade" id="entityAddScore" role="tabpanel"
                                                     aria-labelledby="custom-tabs-two-home-tab">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="scoreText">Задайте понятное имя счету</label>
                                                                <input
                                                                    type="text"
                                                                    ref="scoreName"
                                                                    class="form-control"
                                                                    placeholder="Любое имя"
                                                                    @change="changeScoreName"
                                                                >
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="exampleInputFile">Загрузить новый счет</label>
                                                                <div class="input-group">
                                                                    <div class="custom-file">
                                                                        <input
                                                                                ref="score"
                                                                                type="file"
                                                                                class="custom-file-input"
                                                                                id="exampleInputFile"
                                                                                @change="changeScore"
                                                                        >
                                                                        <label class="custom-file-label" for="exampleInputFile">Выбрать файл</label>
                                                                    </div>
                                                                    <div class="input-group-append">
                                                                        <span
                                                                                class="input-group-text cursor-pointer"
                                                                                v-on:click="sendScore"
                                                                        >Загрузить</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <history-entity
                                    :history="this.user.history"
                                    :historyParams="this.user.historyParams"
                                ></history-entity>
                            </div>

                            <template v-if="this.user.isBuyer">
                                <div class="tab-pane" id="scores">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <template v-if="this.user.scores.length">
                                                <scores
                                                    :documents="this.user.scores"
                                                    action="delete"
                                                ></scores>
                                            </template>
                                            <template v-else>
                                                <p>Счета не загружены</p>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="tab-pane" id="buyings">

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="card">
                                            <div class="card-header">
                                                <template v-if="this.user.isBuyer">
                                                    <h3 class="card-title">Закупки, которые создал покупатель или к которым присоединился (включая черновики). Всего - {{ this.buyingTableOptions.data.length }}</h3>
                                                </template>
                                                <template v-if="this.user.isSeller">
                                                    <h3 class="card-title">Закупки, в которых поставщик одержал победу или выигрывает на текущий момент. Всего - {{ this.buyingTableOptions.data.length }}</h3>
                                                </template>
                                            </div>
                                            <div class="card-body">
                                                <data-table
                                                    ref="table"
                                                    :fields="buyingTableFields"
                                                    :opts="buyingTableOptions"
                                                ></data-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane" id="requests">
                                <request-component v-if="this.user.isBuyer" :requests="this.user.requests.requests" :from = "'admin'"></request-component>
                            </div>


                            <div class="tab-pane" id="wallet">
                                <div class="row">
                                    <div class="col-sm-12 mb-4">
                                        Текущий баланс пользователя в рублях -
                                        <input type="number" min="0" step="0.01" :value="this.user.money" ref="userMoney" />

                                        <button type="button" class="btn btn-success btn-sm" @click="userMoneyChange">
                                            Изменить
                                        </button>
                                    </div>
                                    <div class="col-sm-12">
                                        <template v-if="this.user.payments.length">

                                        <div class="card">
                                            <div class="card-header border-transparent">
                                                <h3 class="card-title">Пополнения</h3>

                                                <div class="card-tools">
                                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                                        <i class="fas fa-minus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                                <div class="card-body p-0">
                                                    <div class="table-responsive">
                                                        <table class="table m-0">
                                                            <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Сумма, р</th>
                                                                <th>Способ</th>
                                                                <th>Статус</th>
                                                                <th>Дата</th>
                                                                <th></th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <template v-for="payment in this.user.payments">
                                                                <tr>
                                                                    <td>{{ payment.uid }}</td>
                                                                    <td>{{ payment.sum }}</td>
                                                                    <td>{{ payment.type }}</td>
                                                                    <td>
                                                                        <span :class="payment.statusClasses">{{ payment.status }}</span>
                                                                    </td>
                                                                    <td>
                                                                        {{ payment.createdAsData }} {{ payment.createdAsTime }}
                                                                    </td>
                                                                    <td>
                                                                        <template v-if="payment.isStatusCreated">
                                                                        <div class="btn-group">
                                                                            <button type="button" class="btn btn-info btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                <i class="fas fa-edit"></i> Действие
                                                                            </button>
                                                                            <div class="dropdown-menu">
                                                                                <button class="dropdown-item" @click="changeStatusPayment(payment.id, 'paid')">Подтвердить</button>
                                                                                <button class="dropdown-item" @click="changeStatusPayment(payment.id, 'canceled')">Отменить</button>
                                                                            </div>
                                                                        </div>
                                                                        </template>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane" id="settings">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Админская роль</label>
                                                <multiselect
                                                        v-model="crmUserRole"
                                                        selectLabel="Нажмите для добавления"
                                                        deselectLabel="Нажмите для удаления"
                                                        selectedLabel="Выбрано"
                                                        placeholder="Выберите роль доступа в CRM"
                                                        label="name"
                                                        track-by="id"
                                                        :options="crmRoles"
                                                        :multiple="false"
                                                        :searchable="false"
                                                        @input="changeUserRole"
                                                ></multiselect>
                                        </div>

                                        <!-- Button trigger modal -->
                                        <button type="button" class="btn btn-info" data-toggle="modal" data-target="#exampleModal">
                                            Посмотреть разрешения
                                        </button>

                                        <!-- Modal -->
                                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="exampleModalLabel">Разрешения пользователя</h5>
                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <template v-if="this.user.responsible.crmUserRole.permission">
                                                            <ul class="list-group">
                                                                <li class="list-group-item" v-for="role in this.user.responsible.crmUserRole.permission">{{ role }}</li>
                                                            </ul>
                                                        </template>
                                                        <template v-else>
                                                            Данный пользователь не имеет доступа в CRM
                                                        </template>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="disabledBlock" class="row" v-else>
            <div class="col-md-12">
                <p>Пользователь не найден</p>
            </div>
        </div>
    </div>
</template>

<script>

    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import Multiselect from 'vue-multiselect'

    import CrmService from '../../services/CrmService';

    import HistoryEntity from "./HistoryEntityComponent";
    import DocumentTable from "./DocumentTableComponent";
    import RequestComponent from "../RequestComponent";

    import VdtnetTable from 'vue-datatables-net';

    import axios from 'axios';

    Vue.component('multiselect', Multiselect);

    const COMPONENT_NAME = 'user-show';

    export default {
        name: COMPONENT_NAME,
        components: {
            RequestComponent,
            'multiselect': Multiselect,
            'history-entity': HistoryEntity,
            'scores': DocumentTable,
            'requests': RequestComponent,
            'data-table': VdtnetTable,
        },
        props: ['userId'],
        data() {
            return {
                user: null,
                crmUserRole: [],
                crmRoles: [],
                buttonsCommentFocused: false,

                actionData: {},
                historyCommentText: null,

                buyingTableOptions: {
                    data: [],
                    buttons: ['copy', 'csv', 'print'],
                    /*eslint-disable */
                    dom: "Btr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
                    /*eslint-enable */
                    responsive: true,
                    processing: true,
                    searching: true,
                    searchDelay: 1500,
                    destroy: true,
                    ordering: true,
                    lengthChange: true,
                    serverSide: false,
                    fixedHeader: true,
                    saveState: true,
                    language: {
                        url: "http://cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Russian.json"
                    }
                },
                buyingTableFields: {
                    id: { label: 'ID', sortable: true },
                    status: {
                        label: 'Статус',
                        sortable: true,
                        searchable: true,
                        defaultOrder: 'desc',
                        render: (data, type, row) => {
                            return this.buyingLink(row.id, row.type, row.status);
                        }
                    },
                    offerDate: { label: 'Завершается', sortable: true, searchable: true, defaultOrder: 'desc' },
                    products: {
                        label: 'Товары',
                        sortable: true,
                        searchable: true,
                        defaultOrder: 'desc',
                        render: (data) => {
                            let result = '';
                            if(data.length) {
                                for (let i = 0; i < data.length; i++) {
                                    result += data[i].name + '<br>';
                                }
                            }
                            return result;
                        }
                    },
                },
            }
        },
        mounted() {

            // Добавляем общую блокировку
            this.blockedWrapPage(true);

            this.updateComponent();
        },
        methods: {
            updateComponent() {
                this.getUser();
            },
            async getUser() {
                try {
                    let response = await CrmService.getUser(this.userId);
                    if (response.success) {
                        this.user = response.user;

                        this.crmUserRole = response.user.responsible.crmUserRole;
                        this.crmRoles = response.user.responsible.crmRoles;

                        this.buyingTableOptions.data = response.user.buyings;

                        // Убираем блокировку всего блока
                        this.blockedWrapPage(false);
                    } else {
                        alert(response.error.message)
                    }
                } catch (e) {
                    console.error(e);
                }
            },

            // Блокируем общий фон при загрузке
            blockedWrapPage(method) {
                if (method === true) {
                    $('#disabledBlock').addClass('disabled');
                    $('#disabledBlockWrap .spinner-center').show();
                } else {
                    $('#disabledBlock').removeClass('disabled');
                    $('#disabledBlockWrap .spinner-center').hide();
                }
            },

            // Ссылка на профиль пользователя
            userLink(id) {
                return `/admin/users/show?id=${id}`;
            },

            // Смена фокуса в блоке отправки комментария
            onFocusButtonsComment(event) {
                this.buttonsCommentFocused = true;
                event.target.rows = 4;
            },
            onBlurButtonsComment() {
                this.buttonsCommentFocused = false;
            },

            // Отправка комментария о пользователе
            async sendComment() {

                // Если нет коммента
                if(!this.historyCommentText) {
                    alert('Введите комментарий');
                    return;
                }

                this.actionData['commentText'] = this.historyCommentText;

                let response = await CrmService.sendHistoryEntity(this.user.entityType, this.user.id, this.actionData);
                if (response) {
                    this.$message('Успешное выполнение');
                    this.historyCommentText = null;
                    this.actionData = {};
                    this.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Смена роли
            async changeUserRole (value) {

                // Ток админы могут менять роль
                if(!this.user.authResponsible.isAdmin) {
                    alert('У вас нет разрешения на это действие');
                    this.crmUserRole = [];
                    return;
                }

                let role = value ? value.id : 'clear';

                let response = await CrmService.changeUserRole(this.user.id, role);
                if (response.success) {
                    this.$message('Роль обновлёна');
                    this.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Изменить счет
            changeScore () {
                this.actionData['score'] = this.$refs.score.files[0];
            },

            // Изменить имя счету
            changeScoreName () {
                this.actionData['scoreName'] = this.$refs.scoreName.value;
            },

            // Загрузить счет
            async sendScore () {

                // Если пытаются загрузить не покупателю
                if(!this.user.isBuyer) {
                    alert('Прикрепить счет можно только покупателю');
                    return;
                }
                // Если не задано имя счету
                if(!this.actionData['scoreName']) {
                    alert('Укажите имя загружаемому счёту');
                    return;
                }

                // Если не выбран файл
                if(!this.actionData['score']) {
                    alert('Выберите счет');
                    return;
                }

                let formData = new FormData();
                formData.append('file', this.actionData['score']);
                formData.append('scoreName', this.actionData['scoreName']);
                formData.append('userId', this.user.id);

                let response = await CrmService.sendScore(formData);
                if (response.success) {
                    this.$message('Счет загружен');
                    this.actionData = {};
                    this.$refs.scoreName.value = '';
                    this.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Смена статуса пополнения средств
            async changeStatusPayment(id, status) {

                if (!window.confirm('Вы действительно хотите изменить статус платежа?')) {
                    return;
                }

                let comment = prompt('Введите комментарий к смене статуса платежа если это требуется', '');
                if (comment === null) {
                    return;
                }

                let response = await CrmService.changeStatusPayment(id, status, comment);
                if (response.success) {
                    this.$message('Статус платежа изменен');
                    this.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Изменение балланса юзера
            async userMoneyChange() {

                if (!window.confirm('Вы действительно хотите изменить баланс?')) {
                    return;
                }
                let money = parseFloat(this.$refs.userMoney.value);

                let response = await CrmService.changeUserMoney(this.user.id, money);
                if (response.success) {
                    this.$message('Баланс изменен');
                }else{
                    this.$message('Произошла ошибка');
                }
                this.updateComponent();
            },

            // Ссылка на закупку
            buyingLink(id, type, name) {
                return `<a href="/admin/default/buying?buyingId=${id}&buyingType=${type}" target="_blank">${name}</a>`;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .user-show {

        .profile-username {
            font-size: 40px;

            span {
                font-size: 21px;
                color: #919191;
            }
        }
    }

    #disabledBlockWrap {
        position: relative;

        #disabledBlock.disabled {
            opacity: 0;
            pointer-events: none;
        }

        .spinner-center {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: none;
            font-size: 40px;
        }

        .cursor-pointer {
            cursor: pointer;
        }
    }
</style>